import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { PULSE_QUERY_KEYS } from './keys';

import { fetchOffboardFeedbacks } from 'services/offboardFeedback';

export interface OffboardFeedbackItem {
  id: number;
  subject: { id: number; fullName: string };
  project?: { id: number; name: string } | null;
}

export function useOffboardFeedbackQuery(
  userId: string,
  shouldFetch = true
): UseQueryResult<OffboardFeedbackItem[], Error> {
  return useQuery<unknown, Error, OffboardFeedbackItem[]>({
    queryKey: [PULSE_QUERY_KEYS.OFFBOARD_FEEDBACK, userId],
    queryFn: () => fetchOffboardFeedbacks({ userId }),
    enabled: shouldFetch && Boolean(userId),
    select: (data) => (Array.isArray(data) ? data : []),
  });
}
